import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { ServiceLaneFacade } from '@quorum/service-lane-root/facade';

@Component({
  selector: 'svc-toyota-dashboard',
  templateUrl: './toyota-dashboard.component.html',
  styleUrls: ['./toyota-dashboard.component.scss'],
})
export class ToyotaDashboardComponent implements OnInit, OnChanges {
  @Input() collapsed: boolean;
  campaigns$: any;
  constructor(public serviceLaneFacade: ServiceLaneFacade) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {}

  toggleCollapse(groupUiObject: any) {
    groupUiObject.collapsed = !groupUiObject.collapsed;
  }
}
